// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalProjectNoteDelete_base__3kIjw"};